export default "__VITE_ASSET__DFsDhVgZ__"